import { ReactNode } from 'react';

import Footer from 'components/footer';
import Header from 'components/header';
import { MainLayoutWrapper } from './styles';

type MainLayoutProps = {
  transparentHeader?: boolean;
  children: ReactNode;
};

function MainLayout({ children, transparentHeader }: MainLayoutProps) {
  return (
    <MainLayoutWrapper>
      <Header transparentHeader={transparentHeader} />
      <main>{children}</main>
      <Footer />
    </MainLayoutWrapper>
  );
}

export default MainLayout;
